// extracted by mini-css-extract-plugin
export default {"xpManagerModal":"styles_xpManagerModal__gu+jr","xpManager":"styles_xpManager__2okDm"};